import styled from 'styled-components';
import { isNil } from '@/app/components/search/Utilities.ts';

const Parenthesis = styled.span`
  .sidebar & {
    display: none;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const formatLabelCounter = (counter: number | null | undefined): React.JSX.Element | string =>
  !isNil(counter) ? (
    <span>
      <Parenthesis aria-hidden={true}>(</Parenthesis>
      {counter}
      <Parenthesis aria-hidden={true}>)</Parenthesis>
    </span>
  ) : (
    ''
  );
